<template>
  <div class="game_box">
    <div class="game_title">{{ $t("router.appMaterial") }}</div>
    <div class="xian"></div>
    <div class="app app_API">
      <div class="app_box_title">
        <div class="app_title_text"></div>
        <div class="appadd CU" @click="showmodal">
          <img src="@/img/set_img.png" alt="" />
          <span>{{ $t("appinfo.material.addApp") }}</span>
        </div>
      </div>
      <div class="app_table">
        <a-config-provider>
          <template
            v-if="datalist == '' && datalist.length <= 0"
            #renderEmpty
            style=""
          >
            <div style="text-align: center; margin-top: 100px">
              <img src="@/img/kong.png" alt="" />
              <p>{{ $t("gameinfo.rank.no_result") }}</p>
            </div>
          </template>
          <a-table
            :loading="loading"
            :scroll="{ x: true }"
            :columns="columns"
            :data-source="datalist"
            :rowKey="
              (record, index) => {
                return index;
              }
            "
          >
            <template slot="id" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="appName" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="unit" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="idx" slot-scope="text, record, index">
              {{ text }}
            </template>
            <template slot="type" slot-scope="text, record, index">
              {{ text }}
            </template>

            <template slot="operation" slot-scope="text, record, index">
              <span @click="alterModal(record)">
                <a>{{ $t("gameinfo.rank.alter") }}</a>
              </span>
              <span @click="onDeleteModel(record.id)" style="margin-left: 10px">
                <a>{{ $t("gameinfo.rank.deletes") }}</a>
              </span>
            </template>
          </a-table>
        </a-config-provider>
      </div>
    </div>

    <div class="modal_box" v-if="ismodal">
      <div class="modal_bg"></div>
      <div class="modal">
        <div class="modal_nav">
          <div class="modal_title" v-if="changeinfo">
            {{ $t("appinfo.material.updateApp") }}
          </div>
          <div class="modal_title" v-else>
            {{ $t("appinfo.material.addApp") }}
          </div>
          <div class="modal_url CU" @click="close">
            <img class="modal_img" src="@/img/close.png" alt="" />
          </div>
        </div>
        <div class="">
          <div class="BASIC2 MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT">
                <span class="must">*</span>
                {{ $t("foundapp.apptype") }}
              </div>
              <div class="radio_btn">
                <div class="CU radio_chunk" @click="SelectAppType('Android')">
                  <img
                    class="radio_img"
                    v-if="appInfo.appType === 'Android'"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{ $t("foundapp.android") }}</span>
                </div>
                <div class="CU radio_chunk" @click="SelectAppType('iOS')">
                  <img
                    class="radio_img"
                    v-if="appInfo.appType === 'iOS'"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{ $t("foundapp.ios") }}</span>
                </div>
                <div class="CU radio_chunk" @click="SelectAppType('Web')">
                  <img
                    class="radio_img"
                    v-if="appInfo.appType === 'Web'"
                    src="@/img/radio.png"
                    alt=""
                  />
                  <img
                    class="radio_img"
                    v-else
                    src="@/img/no_radio.png"
                    alt=""
                  />
                  <span class="radio_text">{{ $t("foundapp.web") }}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="BASIC2 MG_B10"
            v-if="appInfo.appType === 'Android' || appInfo.appType === 'iOS'"
          >
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span>{{ $t("foundapp.packageName") }}
              </div>
              <input
                type="text"
                style="height: 40px; width: 366px"
                v-model="appInfo.packageName"
                class="TGA_INPUT TGA_PD"
                @input.prevent="changeCount()"
                :placeholder="$t('foundapp.packageName')"
              />
            </div>
          </div>
          <div class="BASIC2 MG_B10">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 90px">
                <span class="must">*</span>
                {{ $t("appinfo.material.logo") }}
              </div>
            </div>

            <div class="updata CU">
              <el-upload
                :action="upload_url"
                :drag="false"
                class="avatar-uploader"
                :http-request="up_load"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
              >
                <img
                  v-if="appInfo.icon"
                  :src="appInfo.icon"
                  style="width: 90px; height: 90px"
                  class="avatar"
                />
                <img
                  v-else
                  class="upload_img"
                  style="width: 90px; height: 90px"
                  :src="$t('appinfo.material.uploadimg')"
                  alt=""
                />
              </el-upload>
            </div>
            <div class="init_text">
              <ul>
                <li>{{ $t("appinfo.material.format") }}</li>
                <li>{{ $t("appinfo.material.size") }}</li>
                <li>{{ $t("appinfo.material.size2") }}</li>
              </ul>
            </div>
          </div>

          <div class="BASIC2 MG_B25" style="display: block">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                <span class="must">*</span
                >{{ $t("appinfo.material.apppackageurl") }}
              </div>
              <input
                type="text"
                style="height: 40px; width: 366px"
                v-model="appInfo.packageUrl"
                class="TGA_INPUT TGA_PD"
                @input.prevent="changeCount()"
                :placeholder="$t('appinfo.material.apppackageurl')"
              />
            </div>
            <div class="copytext">
              {{ $t("appinfo.material.appservice") }}
            </div>
          </div>

          <div class="BASIC2 MG_B25" style="display: block">
            <div class="TGA_INPUT_BOX">
              <div class="TGA_TEXT" style="line-height: 40px">
                {{ $t("foundapp.description") }}
              </div>
              <input
                type="text"
                style="height: 40px; width: 366px"
                v-model="appInfo.description"
                class="TGA_INPUT TGA_PD"
              />
            </div>
          </div>
        </div>
        <div class="modal_btn CU" @click="save">
          {{ $t("gameinfo.rank.send") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import configs from "@/utils/config.js";
export default {
  data() {
    return {
      id: this.$route.query.id,
      loading: true,
      configs: configs.serviceEmail(),
      ismodal: false,
      changeinfo: false,
      appId: "",
      appInfo: {
        id: "",
        appType: "Android",
        packageName: "",
        packageUrl: "",
        icon: "",
        description: "",
        description: "",
      },
      upload_url: "",
      openfileUrl: "",
      upload_file: "",
      fileUrlState: false,
      BTN: false,
      datalist: [],
      pagination: {
        defaultCurrent: 1,
        total: 0,
        pageSize: 20, //每页中显示20条数据
      },
      columns: [
        {
          title: this.$t("foundapp.apptype"),
          dataIndex: "appType",
          key: "appType",
          scopedSlots: { customRender: "appType" },
          customRender: (text, record) => {
            var data = text;
            if (text == "Android") {
              data = this.$t("foundapp.android");
            } else if (text == "iOS") {
              data = this.$t("foundapp.ios");
            } else if (text == "Web") {
              data = this.$t("foundapp.web");
            }
            return data;
          },
        },
        {
          title: this.$t("foundapp.packageName"),
          dataIndex: "packageName",
          key: "packageName",
          scopedSlots: { customRender: "rankName" },
          customRender: (text, record) => {
            var data = text;
            return text;
          },
        },
        {
          title: this.$t("foundapp.description"),
          dataIndex: "description",
          key: "description",
          scopedSlots: { customRender: "description" },
          customRender: (text, record) => {
            var data = text;
            return text;
          },
        },
        {
          title: this.$t("gameinfo.rank.action"),
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" },
        },
      ],
      pageNum: 1,
      count: 10,
    };
  },
  computed: {
    ...mapState("game", ["GameAppInfo", "baseInfo"]),
  },
  created() {},
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions("user", [
      "tipMessage",
      "FileUpload",
      "FileContraZip",
      "FileUnZip",
      "FileState",
    ]),
    ...mapActions("game", [
      "AppInfo",
      "createAppInstances",
      "updateAppInstances",
      "deleteAppInstances",
    ]),
    async load() {
      var res = await this.AppInfo({
        $axios: this.$axios,
        id: this.id,
      });
      if (res.code == 200) {
        this.datalist = res.data.instances;
        this.appId = res.data.appId;
        this.loading = false;
      }
    },
    SelectAppType(index) {
      this.appInfo.appType = index;
    },

    // 点击预览
    preview() {
      window.open(this.openfileUrl);
    },

    changeCount() {
      this.btnselect();
    },

    btnselect() {
      if (this.appInfo.icon != "" && this.appInfo.packageUrl != "") {
        this.BTN = true;
      } else {
        this.BTN = false;
      }
    },

    up_load_file(file) {},

    beforeAvatarUpload(file) {
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type == "image/png" ||
        file.type === "image/gif";
      const isLt2M = file.size / 1024 < 100;
      if (!isJpgOrPng) {
        this.$message.error(this.$t("appinfo.material.onthecrossimg"));
        return false;
      }
      if (!isLt2M) {
        this.$message.error(this.$t("appinfo.material.onthecrosslogo"));
        return false;
      }
      this.Upload(file, "img");
      this.IsImgstate = true;
      return true;
    },

    up_load(file) {},
    async Upload(file, state) {
      var res = await this.FileUpload({
        $axios: this.$axios,
        file: file,
      });
      if (res.stateCode == 1) {
        this.IsImgstate = false;
        this.appInfo.icon = res.resultInfo.data;
        this.btnselect();
      }
    },

    // 点击复制
    copy(data) {
      let url = data;
      let oInput = document.createElement("input");
      oInput.value = url;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      console.log(oInput.value);
      document.execCommand("Copy"); // 执行浏览器复制命令
      this.$message.info(this.$t("appinfo.material.copysuccess"));
      oInput.remove();
    },

    Newdata(data) {
      var d = new Date(data);
      var year = d.getFullYear(); //年
      var month = d.getMonth() + 1; //月
      var day = d.getDate(); //日
      var hh = d.getHours(); //时
      var mm = d.getMinutes(); //分
      var ss = d.getSeconds(); //秒
      var clock = year + "-";
      if (month < 10) clock += "0";
      clock += month + "-";
      if (day < 10) clock += "0";
      clock += day + " ";
      if (hh < 10) clock += "0";
      clock += hh + ":";
      if (mm < 10) clock += "0";
      clock += mm + ":";
      if (ss < 10) clock += "0";
      clock += ss;
      return clock;
    },

    showmodal() {
      this.init();
      this.ismodal = true;
      this.changeinfo = false;
    },

    init() {
      this.appInfo = {
        id: "",
        appType: "Android",
        packageName: "",
        packageUrl: "",
        icon: "",
        description: "",
        description: "",
      };
    },

    close() {
      this.ismodal = false;
    },
    async save() {
      if (this.appInfo.appType === "Web") {
        if (this.appInfo.icon === "" || this.appInfo.packageUrl === "") {
          this.$message.error(this.$t("gameinfo.rank.error"));
          return;
        }
      } else {
        if (
          this.appInfo.icon === "" ||
          this.appInfo.packageUrl === "" ||
          this.appInfo.packageName === ""
        ) {
          this.$message.error(this.$t("gameinfo.rank.error"));
          return;
        }
      }
      if (!this.changeinfo) {
        this.addsave();
      } else {
        this.Editsave();
      }
    },
    async addsave() {
      const res = await this.createAppInstances({
        $axios: this.$axios,
        appId: this.appId,
        appType: this.appInfo.appType,
        packageName: this.appInfo.packageName,
        packageUrl: this.appInfo.packageUrl,
        icon: this.appInfo.icon,
        description: this.appInfo.description,
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.save_success"));
        this.ismodal = false;
        this.load();
      } else {
        this.$message.error(this.$t("gameinfo.rank.save_error"));
      }
    },
    async Editsave() {
      const res = await this.updateAppInstances({
        $axios: this.$axios,
        id: this.appInfo.id,
        appType: this.appInfo.appType,
        packageName: this.appInfo.packageName,
        packageUrl: this.appInfo.packageUrl,
        icon: this.appInfo.icon,
        description: this.appInfo.description,
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.edit_success"));
        this.ismodal = false;
        this.load();
      } else {
        this.$message.error(this.$t("gameinfo.rank.edit_error"));
      }
    },

    // 获取排行榜信息
    async alterModal(data) {
      this.changeinfo = true;
      this.ismodal = true;
      console.log("data", data);
      this.appInfo = data;
    },

    onDeleteModel(id) {
      const self = this;
      this.$confirm({
        content: self.$t("gamelist.isDelete"),
        okText: self.$t("gameinfo.rank.ok"),
        cancelText: self.$t("gameinfo.rank.cancel"),
        onOk() {
          self.onDelete(id);
        },
      });
    },
    // 删除
    async onDelete(id) {
      const res = await this.deleteAppInstances({
        $axios: this.$axios,
        id: id,
      });
      if (res.code == 200) {
        this.$message.success(this.$t("gameinfo.rank.delete_success"));
        this.load();
      } else {
        this.$message.error(this.$t("gameinfo.rank.delete_error"));
      }
    },
  },
};
</script>

<style scoped="scoped">
.app_box {
  width: 100%;
  height: 100%;
}
.app_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}

.app {
  padding: 0 39px 0 50px;
  margin-top: 31px;
}

.app_box_title {
  margin-top: 30px;
  display: flex;
  justify-content: space-between;
}
.app_title_text {
  font-size: 14px;
  color: #666666;
  display: flex;
  align-items: center;
}
.appadd {
  width: 133px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.appadd img {
  width: 14px;
  height: 14px;
  margin-right: 6px;
}
.appadd span {
  line-height: 14px;
  font-size: 14px;
}
.app_table {
  margin-top: 20px;
}
.game_box {
  width: 100%;
  min-height: 500px;
  /* height: ; */
}
.game_title {
  padding-left: 50px;
  font-size: 18px;
  color: #282828;
}
.xian {
  width: 100%;
  height: 1px;
  margin-top: 14px;
  background-color: #f3f3f3;
}
.game {
  margin-top: 31px;
  /* padding-left: 50px; */
}
.material {
  padding-left: 175px;
}
.material .TGA_TEXT {
  line-height: 90px;
}
.material_box {
  display: flex;
}
.file {
  margin-top: 25px;
}

.init_text {
  margin-left: 138px;
  color: #aaaaaa;
  font-size: 12px;
}
.init_text ul {
  padding: 0;
  margin: 0;
  padding-top: 15px;
}
.init_text ul li {
  line-height: 12px;
  margin-bottom: 10px;
}
.init_text ul li:nth-last-of-type(1) {
  margin-bottom: 0;
}

.router_init_text {
  margin-top: 14px;
  font-size: 12px;
  color: #999999;
}
.router_init_text_active {
  color: #f65651;
}
.router_init_text span {
  color: #4990fa;
}

.file_text_box {
  margin-top: 19px;
  width: 613px;
  color: #aaaaaa;
}
.file_text_box .file_text {
  font-size: 12px;
  line-height: 20px;
  word-break: break-all;
}
.hint {
  margin-top: 29px;
  font-size: 12px;
  color: #f65651;
}
.hint span {
  color: #4990fa;
}

.btn {
  margin: 25px 0 0 0px;
  width: 120px;
  height: 40px;
  background-color: #4990fa;
  border-radius: 4px;
  text-align: center;
  line-height: 40px;
  color: #ffffff;
  font-size: 14px;
}
.btn_active {
  background-color: #dddddd;
}
.game_btn_preview {
  width: 120px;
  height: 40px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #aaaaaa;
  color: #666666;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  margin-left: 118px;
}
.game_btn_box {
  display: flex;
  align-items: center;
}

.uploadSuccess {
  width: 90px;
  height: 90px;
  display: flex;
  align-items: center;
  /* border: 1px solid #dddddd; */
}
.MG_B25 {
  margin-bottom: 25px;
}
.time_text {
  height: 40px;
  line-height: 40px;
}

.app_btn_active {
  background-color: #fff;
  border: solid 1px #aaaaaa;
  color: #666666;
}

.copytext {
  color: #999999;
  font-size: 12px;
  margin-top: 14px;
}

.loading_box {
  height: 500px;
}

.modal_box {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal_bg {
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.8;
  z-index: 1;
  width: 100%;
  height: 100%;
}
.modal {
  position: relative;
  z-index: 2;
  width: 800px;
  height: 600px;
  background-color: #fff;
  box-shadow: 0px 2px 30px 0px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
}
.modal_nav {
  margin-bottom: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal_title {
  font-size: 14px;
  color: #282828;
  padding: 20px 0 0 20px;
}
.modal_url {
  box-sizing: border-box;
  padding: 20px 20px 0 0;
}
.modal_img {
  width: 15px;
  height: 15px;
}

.modal_text {
  width: 496px;

  font-size: 12px;
  color: #aaaaaa;
}
.modal_text_active {
  width: 496px;

  font-size: 12px;
  color: #f65651;
}
.radio_btn {
  height: 50px;
  width: 367px;
  display: flex;
  align-items: center;
}
.radio_chunk {
  display: flex;
  align-items: center;
  margin-right: 40px;
}

.radio_text {
  color: #282828;
  font-size: 14px;
  margin-left: 10px;
}
.modal_btn {
  margin: 40px auto 0;
  width: 90px;
  height: 36px;
  background-color: #4990fa;
  border-radius: 4px;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal {
  margin-bottom: 20px;
}
.BASIC2 {
  display: flex;
  margin-bottom: 25px;
  padding-left: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/app/appinfo/material.vue